module.exports = __webpack_public_path__ + "img/2.ecda0739.png";